import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function CardIcon({
  color,
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ').trim()}
      color={color}
      fontSize={size}
      style={style}
      viewBox='0 0 16 16'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M0 4.139C0 3.37186 0.621858 2.75 1.389 2.75H14.611C15.3781 2.75 16 3.37186 16 4.139V10.25V11.861C16 12.6281 15.3781 13.25 14.611 13.25H1.389C0.621858 13.25 0 12.6281 0 11.861V10.25V4.139ZM1 10.75V11.861C1 12.0759 1.17414 12.25 1.389 12.25H14.611C14.8259 12.25 15 12.0759 15 11.861V10.25V4.139C15 3.92414 14.8259 3.75 14.611 3.75H1.389C1.17414 3.75 1 3.92414 1 4.139V9.75H6.269C6.54514 9.75 6.769 9.97386 6.769 10.25C6.769 10.5261 6.54514 10.75 6.269 10.75H1ZM9.376 5.3301H13.278C13.6761 5.3301 14 5.65396 14 6.0521V8.0281C14 8.42624 13.6761 8.7501 13.278 8.7501H9.376C8.97685 8.7501 8.654 8.42624 8.654 8.0281V6.0521C8.654 5.65396 8.97685 5.3301 9.376 5.3301ZM9.654 7.7501H13V6.3301H9.654V7.7501Z'
          fill='currentColor'
        />
      </g>
    </svg>
  );
}
